import { render, staticRenderFns } from "./DealerWaitRoutesSection.vue?vue&type=template&id=14540693&scoped=true"
import script from "./DealerWaitRoutesSection.vue?vue&type=script&lang=js"
export * from "./DealerWaitRoutesSection.vue?vue&type=script&lang=js"
import style0 from "./DealerWaitRoutesSection.vue?vue&type=style&index=0&id=14540693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14540693",
  null
  
)

export default component.exports